import React, { useRef, useState } from "react";

import ReactToPrint from "react-to-print";

import AuditoriaService from "../../../main/services/AuditoriaService";
import { ComponentToPrintAuditoriaServico } from "../ComponentToPrintAuditoriaServico";
import { ComponentToPrintAuditoriaCrianca } from "../ComponentToPrintAuditoriaCrianca";

const customPageStyle = `
  @page {
    margin: 0mm;
    size: auto;
    margin-top: 0mm;
    margin-bottom: 12mm;
  }
  @media print {
    body {
      -webkit-print-color-adjust: exact;
    }
  }
`;

export const PrintButtonAuditoria = ({ visao, id, filtrosOrigem, trigger }) => {
  const componentToPrintRef = useRef(null);
  const [relatorio, setRelatorio] = useState(null);
  const [loading, setLoading] = useState(false);

  const beforeGetContent = async () => {
    setLoading(true);
    try {
      const buscar =
        visao === "SERVICO"
          ? AuditoriaService.buscarRelatorioServico
          : AuditoriaService.buscarRelatorioCrianca;

      const res = await buscar(id, filtrosOrigem || {});
      setRelatorio(res?.data || null);
    } catch (erro) {
      console.log("Erro ao buscar o relatório de auditoria");
      console.log(erro);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ReactToPrint
        onBeforeGetContent={beforeGetContent}
        pageStyle={customPageStyle}
        documentTitle={`MCA - Relatório de Auditoria - ${
          visao === "SERVICO"
            ? "Serviço de Acolhimento"
            : "Criança e Adolescente"
        }`}
        trigger={() => trigger(loading)}
        content={() => componentToPrintRef.current}
      />
      <div style={{ display: "none" }}>
        {visao === "SERVICO" ? (
          <ComponentToPrintAuditoriaServico
            ref={componentToPrintRef}
            relatorio={relatorio}
          />
        ) : (
          <ComponentToPrintAuditoriaCrianca
            ref={componentToPrintRef}
            relatorio={relatorio}
          />
        )}
      </div>
    </>
  );
};
